<div class="container-fluid p-0 partner-dashboard">
    <div class="card border-0 mb-3">
        <div class="card-header generalbgColorV2 border-white">
            <h5 class="text-white font-weight-bolder">Espace operateur plateforme - Retrait business</h5>
        </div>
        <div class="card-body">
            <div class="row align-items-end">
                <div class="col-md-6 mb-2">
                    <label class="font-weight-bold">Compte business</label>
                    <input type="text" class="form-control" [(ngModel)]="withdrawAccountNumber"
                        placeholder="Ex: Z336036389">
                </div>
                <div class="col-md-3 mb-2">
                    <button type="button" class="btn btn-primary btn-block" (click)="generateBusinessWithdrawCode()"
                        [disabled]="generatingWithdrawCode">
                        {{ generatingWithdrawCode ? 'Generation...' : 'Generer code retrait' }}
                    </button>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="badge badge-success p-2" *ngIf="generatedWithdrawCode !== undefined">
                        Code: {{ generatedWithdrawCode }}
                    </div>
                </div>
            </div>
            <div class="text-danger mt-2" *ngIf="withdrawCodeError">{{ withdrawCodeError }}</div>
            <small class="text-muted d-block mt-1">Le transfert ledger FEES vers BUSINESS_MAIN est execute
                automatiquement avant generation du code (compte plateforme type 12).</small>
        </div>
    </div>
    <div class="card  border-0" id="topCard">
        <div class="card-header  generalbgColorV2 border-white">
            <h5 class="text-white font-weight-bolder">Gestion des paiemenents commercant utilisateur de
                softpay</h5>
        </div>

        <div class="card-body border-0 p-0">
            <div class="row">
                <div class="col-sm-6 mb-5">
                    <div class="card  border-0 ">
                        <div class="card-header border-white generalbgColorV2">


                            <div class="d-flex">
                                <div class="p-2">
                                    <h5 class="text-success text-center font-weight-bolder">{{accountNumber}}</h5>
                                </div>

                                <div class="ml-auto p-2">

                                    <button type="button" (click)="getMensualiteAndTaxesList()" class="btn btn-primary"
                                        data-bs-toggle="modal" data-bs-target="#exampleModalTaxes">
                                        Mensualités
                                    </button>


                                </div>
                            </div>



                        </div>
                        <div class="card-body myColorText">
                            <ul class="list-group list-group-flush ">

                                <li class="list-group-item   d-flex justify-content-between align-items-center">
                                    solde générale
                                    <span class="badge badge-success badge-pill">
                                        <h3 class="text-white">{{soldeGenerale| currency:'FCFA'}}</h3>
                                    </span>
                                </li>
                                <li class="list-group-item c d-flex justify-content-between align-items-center">
                                    solde au click
                                    <span class="badge badge-success badge-pill">
                                        <h3 class="text-white">{{totalclickPay| currency:'FCFA'}}</h3>
                                    </span>
                                </li>
                                <li class="list-group-item  d-flex justify-content-between align-items-center">
                                    solde mensuel
                                    <span class="badge badge-success badge-pill">
                                        <h3 class="text-white">{{totalmonthpay| currency:'FCFA'}}</h3>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="card border-0">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="row-border  hover table-borderless table-striped" id="paiement">
                                    <thead>
                                        <tr class="myColorText">
                                            <th scope="col">mois de paiement</th>
                                            <th scope="col">mois de facturation</th>
                                            <th scope="col">source</th>
                                            <th scope="col">abonnement</th>
                                            <th scope="col">montan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="myColorText" *ngFor="let p of paiementList;">
                                            <th scope="row">{{p.aMonth}}/{{p.aYear}}</th>
                                            <td>{{p.month}}/{{p.year}}</td>
                                            <td><button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    (click)="getBaccount(p.source)">{{p.source}}</button></td>
                                            <td>{{p.typ}}</td>
                                            <td>{{p.montan | currency:'FCFA'}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr style="border: 3px solid gray;">
    <div class="card " id="botomCard">
        <p *ngIf="transfert" class="text-success font-weight-bolder">Le prélevement a été effectué.</p>
        <p *ngIf="notTranfering" class="text-danger font-weight-bolder">Le transfert n'a pas été effectué, car le solde
            est insuffisant.</p>
        <p *ngIf="pay" class="text-success text-center font-weight-bolder">Cette facture a déjà été payée.</p>
        <div class="card-header generalbgColorV2 text-white font-weight-bolder">
            Liste de toutes les factures

        </div>
        <div class="card-body ">
            <div class="table-responsive">
                <table class="table row-border   table-borderless table-striped " id="factures">
                    <thead>
                        <tr class="myColorText">
                            <th scope="col">mois de facturation</th>
                            <th>mois de paiement</th>
                            <th>compte</th>
                            <th scope="col">source</th>
                            <th scope="col">abonnement</th>
                            <th scope="col">mensualite</th>
                            <th scope="col">nombre de clic</th>
                            <th scope="col"> prix au clic</th>
                            <th scope="col"> prix total clic</th>
                            <th scope="col">situation</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr class="myColorText" *ngFor="let p of factureList;">
                            <th scope="row">{{p.month}}/{{p.annee}}</th>
                            <td>{{p.validity | date: 'MM/yyyy'}}</td>
                            <th>{{p.source}}</th>
                            <td><button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal" (click)="getBaccount(p.source)">detailles</button></td>
                            <td *ngIf="p.typ==2;else clicktemplate ">au mois</td>
                            <ng-template #clicktemplate>
                                <td>Au clic</td>
                            </ng-template>
                            <td>{{p.mensualite | currency:'FCFA'}}</td>
                            <td>{{p.nclick}}</td>
                            <td>{{p.prixClick | currency:'FCFA'}}</td>
                            <td>{{p.totalPrix | currency:'FCFA'}}</td>
                            <td *ngIf="p.status;else notPaid ">payer</td>
                            <ng-template #notPaid>
                                <td><button type="button" class="btn btn-primary btn-sm"
                                        (click)="makeTransfert(p.id,p.source)">transfert</button></td>
                            </ng-template>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>




<!-- Modal details compte -->
<div class="modal fade partner-modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Détail du compte source</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Fermer"></button>
            </div>
            <div class="modal-body">
                <p class="modal-lead mb-3">Les informations détaillées du compte sélectionné s'affichent dans cette
                    fenêtre.</p>
                <div class="alert alert-info mb-0">
                    Sélectionnez une ligne dans le tableau pour afficher ou actualiser les données du compte.
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
        </div>
    </div>
</div>





<!-- Modal mensualites -->
<div class="modal fade partner-modal taxes-premium-modal bd-example-modal-xl" id="exampleModalTaxes" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalTaxesLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            <div class="modal-header border-0 text-white"
                style="background:linear-gradient(135deg,#0b2c4f 0%,#1e5f98 100%);">
                <div class="taxes-modal-headline">
                    <span class="taxes-kicker">Edition premium</span>
                    <h5 class="modal-title mb-0" id="exampleModalTaxesLabel">Mensualités et taxes</h5>
                    <small class="taxes-modal-subtitle">Historique mensuel des flux de facturation du compte</small>
                </div>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Fermer"></button>
            </div>
            <div class="modal-body py-4 px-3 px-md-4">
                <div class="taxes-panel border rounded-4 p-3 p-md-4" style="background:#ffffff;">
                    <div class="taxes-toolbar d-flex flex-column flex-md-row align-items-md-center mb-3">
                        <p class="modal-lead mb-2 mb-md-0">Synthèse mensuelle des transferts, bénéfices de transfert et taxes
                            collectées.</p>
                        <span class="taxes-count" *ngIf="taxelist?.length">
                            <strong>{{ taxelist.length }}</strong>
                            <small>période(s)</small>
                        </span>
                    </div>

                    <div class="taxes-empty rounded-4 p-3" *ngIf="!taxelist || taxelist.length === 0">
                        <h6 class="mb-1">Aucune mensualité disponible</h6>
                        <p class="mb-0">Les périodes apparaîtront ici dès qu'une mensualité sera calculée pour ce
                            compte.</p>
                    </div>

                    <div class="taxes-legend" *ngIf="taxelist?.length">
                        <span class="badge rounded-pill px-3 py-2"><span class="tax-dot transfer"></span>Transfert</span>
                        <span class="badge rounded-pill px-3 py-2"><span class="tax-dot benefit"></span>Bénéfice
                            transfert</span>
                        <span class="badge rounded-pill px-3 py-2"><span class="tax-dot taxes"></span>Taxes
                            collectées</span>
                    </div>

                    <div class="taxes-grid" *ngIf="taxelist?.length">
                        <article class="taxes-item border rounded-4 p-3 shadow-sm bg-white" *ngFor="let m of taxelist;">
                            <header class="taxes-item-head">
                                <span class="taxes-item-month">{{m.month}}/{{m.annee}}</span>
                                <span class="taxes-item-tag">Mensuel</span>
                            </header>

                            <div class="tax-metric transfer rounded-3">
                                <span class="tax-metric-label"><span class="tax-dot transfer"></span>Total
                                    transfert</span>
                                <span class="tax-metric-value">{{ m.transfert | currency:'FCFA' }}</span>
                            </div>

                            <div class="tax-metric benefit rounded-3">
                                <span class="tax-metric-label"><span class="tax-dot benefit"></span>Bénéfice
                                    transfert</span>
                                <span class="tax-metric-value">{{ m.btransfert | currency:'FCFA' }}</span>
                            </div>

                            <div class="tax-metric taxes rounded-3">
                                <span class="tax-metric-label"><span class="tax-dot taxes"></span>Taxes
                                    collectées</span>
                                <span class="tax-metric-value">{{ m.taxes | currency:'FCFA' }}</span>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0 px-3 px-md-4 pb-4" style="background:#f7fbff;">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
        </div>
    </div>
</div>
